const memberships = [
    { id: 1, membership: "IEEE Computer Society" },
    { id: 2, membership: "ISERN (International Software Engineering Network)" },
    { id: 3, membership: "IEEE Senior Member" },
    { id: 4, membership: "IEEE Professional" },
    { id: 5, membership: "SEMAT (Software Engineering Method and Theory)" },
    { id: 6, membership: "ACM Professional / SIGCSE / SIGSOFT" }
];

export default memberships;